import * as React from 'react';

import classnames from 'classnames';

// @ts-expect-error - imported from .js/.jsx file
import {ArrowDownIcon} from '../../icon/svg/arrow-down-icon';
import {Body} from '../../typography/body';

import styles from './plan-comparison-floating-button.module.css';

type Props = {
    onClick: () => void;
    leftPosition: number;
};

export function PlanComparisonFloatingButton(props: Props) {
    return (
        <button
            onClick={props.onClick}
            style={{left: `${props.leftPosition}px`}}
            className={classnames(
                'flex align-center justify-center gap-8',
                styles['floating-button']
            )}
        >
            <ArrowDownIcon size={15} alignCenter={true} />
            <Body size='normal' color='dark'>
                Compare plans
            </Body>
        </button>
    );
}
